import { Component, inject } from '@angular/core';
import { HlmButton } from '../../../ui/button/src';
import {
  HlmDialogHeader,
  HlmDialogFooter,
  HlmDialogTitle
} from '@spartan-ng/helm/dialog';
import { BrnDialogRef, injectBrnDialogContext } from '@spartan-ng/brain/dialog';

@Component({
  selector: 'app-delete-confirmation-dialog',
  standalone: true,
  imports: [
    HlmButton,
    HlmDialogHeader,
    HlmDialogFooter,
    HlmDialogTitle
  ],
  template: `
    <div class="space-y-4">
      <hlm-dialog-header>
        <h3 hlmDialogTitle>{{ message || 'Delete this item?' }}</h3>
      </hlm-dialog-header>

      <hlm-dialog-footer class="flex gap-3 justify-center sm:justify-center">
        <button hlmBtn variant="outline" (click)="cancel()">Cancel</button>
        <button hlmBtn variant="destructive" (click)="confirm()">Confirm</button>
      </hlm-dialog-footer>
    </div>
  `,
})
export class DeleteConfirmationDialogComponent {
  private dialogRef = inject(BrnDialogRef);
  private context = injectBrnDialogContext<{ message?: string }>();

  message = this.context?.message;

  cancel() {
    this.dialogRef.close(false);
  }

  confirm() {
    this.dialogRef.close(true);
  }
}
